import React from 'react';
import getHtmlAttributes from '../utils/getHtmlAttributes.js';
import LazyVideo from './LazyVideo.jsx';
import Rimg from './Rimg.jsx';
import SVG from './SVG.jsx';

export default function CollectionPromo(props) {
  return props.promoBlocks.filter(promoBlock => {
    if (promoBlock.insert_after) {
      return props.position === 'after';
    } else {
      return props.position === 'before';
    }
  }).map((promoBlock, i) => {
    const htmlAttributes = getHtmlAttributes(promoBlock.shopify_attributes);

    let cName = `promo-block promo-block--${promoBlock.width}`;
    if (promoBlock.desktop_hide && props.isDesktop) {
      return null;
    }
    if (promoBlock.mobile_hide && !props.isDesktop) {
      return null;
    }
    if (promoBlock.video_url) {
      return (
        <li className={cName} key={i} data-promo-item={promoBlock.product} role="cell" {...htmlAttributes}>
          <LazyVideo src={promoBlock.video_url} width={promoBlock.video_width} height={promoBlock.video_height} preload="none" />
          {promoBlock.link && (
            <a className="promo-block--link" href={promoBlock.link} tabIndex="-1" title={props.productTitle} aria-label={props.productTitle}></a>
          )}
        </li>
      )
    }
    if (promoBlock.image && promoBlock.image.src) {
      const dims = {width: promoBlock.image.width, height: promoBlock.image.height};
      if (promoBlock.width === 'double') {
        dims.height = dims.width * 150 / 307;
        dims.crop = 'center';
      }
      return <li className={cName} key={i} data-promo-item={promoBlock.product} role="cell" {...htmlAttributes}>
        <Rimg src={promoBlock.image.src} alt={promoBlock.image.alt || props.productTitle} {...dims} loading="lazy" role="presentation" />
        <a className="promo-block--link" href={promoBlock.link} tabIndex="-1" title={props.productTitle} aria-label={props.productTitle}></a>
      </li>
    } else if (promoBlock.button) {
      let HtmlTag = 'li';
      if (props.htmlTag) {
        HtmlTag = props.htmlTag;
      }
      cName = cName.replace(`promo-block--${promoBlock.width}`, 'promo-block--triple promo-cta');
      return <HtmlTag className={cName} key={i} data-promo-item={promoBlock.product} role="cell" {...htmlAttributes}>
        <span className="promo-block--button">
          <a className="promo-block--button-link" href={promoBlock.link}>
            {promoBlock.button}
            <span className="icon"><SVG icon="arrow-right" /></span>
          </a>
        </span>
      </HtmlTag>
    }
    return (null);
  });
}